import api, { MetadataAttribute, MetadataEntity } from 'api'
import AppAction from 'components/AppAction/AppAction'
import AppTableAction from 'components/AppAction/AppTableAction'
import { AppGridHeard } from 'components/AppGridLayout/AppGridHeard'
import AppGridLayout from 'components/AppGridLayout/AppGridLayout'
import AppGridMenu from 'components/AppGridLayout/AppGridMenu'
import AppGridTabs from 'components/AppGridLayout/AppGridTabs'
import AppGridView from 'components/AppGridLayout/AppGridView'
import AppMessage from 'components/AppMessage'
import { AppTable } from 'components/AppTable'
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'
import React, { Component } from 'react'

interface DataTableProps {
	entityId: number
	application: string
	callBack?: (data: MetadataEntity) => void
	saveData: boolean
}

// 数据对象-字段信息
export default class FieldInformation extends Component<DataTableProps> {
	state = { dataSource: [] as MetadataEntity, entityId: this.props.entityId, application: this.props.application }

	// 渲染前加载
	componentWillMount = async () => {
		let { dataSource, entityId, application } = this.state
		dataSource = await api.modeling.entity.getOne({ id: entityId, application })

		this.setState({ dataSource })
		this.refreshTable(dataSource.metadataAttributeList)
	}
	// 添加
	addTableItem = () => {
		// AppDialog.open(<EntityFieldPage mode={1} entityId={this.state.entityId} afterSave={(metadataAttribute)=>this.afterSave(metadataAttribute)}/>, {
		//   title: '新增字段',
		//   height: 500
		// })
	}
	// 回调保存
	afterSave = (metadataAttribute: MetadataAttribute) => {
		let { dataSource } = this.state
		dataSource.metadataAttributeList = dataSource.metadataAttributeList.filter(e => e.id !== metadataAttribute.id)
		dataSource.metadataAttributeList.push(metadataAttribute)
		this.setState({ dataSource })
		this.refreshTable(dataSource.metadataAttributeList)
	}
	// 编辑
	editTableItem = (metadataAttribute: MetadataAttribute) => {
		// console.log("编辑",metadataAttribute)
		// AppDialog.open(<EntityEditFieldPage mode={2} metadataAttribute={metadataAttribute} afterSave={(data)=>this.afterSave(data)}/>, {
		//   title: '编辑字段',
		//   height: 500
		// })
	}
	// 删除
	deleteTableItem = async (data: MetadataEntity) => {
		let res = await AppMessage.confirm('您确定要删除该字段吗？', true)
		if (res) {
			let { dataSource } = this.state
			dataSource.metadataAttributeList = dataSource.metadataAttributeList.filter(e => e.id !== data.id)
			this.setState({ dataSource })
			this.refreshTable(dataSource.metadataAttributeList)
		}
	}
	// 保存
	saveData = async () => {
		let { dataSource } = this.state
		if (!dataSource) return
		let res = await api.modeling.entity.updateTable(dataSource)
		if (!res) {
			return
		}
	}
	// 刷新Tabe
	refreshTable = (dataSource: any[]) => {
		this.refTable && this.refTable.current && this.refTable.current.fetchDataSource(dataSource)
	}
	refTable = React.createRef<AppTable>()
	render() {
		if ((this, this.props.saveData)) {
			this.saveData()
		}
		return (
			<AppGridLayout defaultViewId={-1}>
				<AppGridSearch
					commonSearchList={[{ dataType: 'string', field: 'name', label: '请输入字段中文名、英文名' }]}
				/>
				<AppGridHeard>
					<AppGridTabs></AppGridTabs>
					<AppGridMenu>
						<AppAction title="新增" type="primary" action={this.addTableItem}></AppAction>
					</AppGridMenu>
				</AppGridHeard>
				<AppGridView viewId={-1}>
					<AppTable
						rowKey="entityId"
						dataSource={this.state.dataSource.metadataAttributeList}
						ref={this.refTable}
						data={this.state.dataSource.metadataAttributeList}
						onApiBefore={data => {
							return data.organId === 0 ? false : data
						}}
					>
						<AppTable.ColIndex />
						<AppTable.Col title="中文名" align="center" field="displayName" width={200} />
						<AppTable.Col title="英文名" align="center" field="name" width={200} />
						<AppTable.Col
							title="是否系统级"
							align="center"
							field="isSystem"
							render={(data: MetadataAttribute) => {
								return <span>{data.isSystem ? '是' : '否'}</span>
							}}
						/>
						<AppTable.Col title="字段类型" align="center" field="attributeType" />
						<AppTable.Col title="数据库字段类型" align="center" field="dbType" />
						<AppTable.Col
							title="是否允许为空"
							align="center"
							field="isNullable"
							render={(data: MetadataAttribute) => {
								return <span>{data.isNullable ? '是' : '否'}</span>
							}}
						/>
						<AppTable.Col
							title="是否主键字段"
							align="center"
							field="isPrimaryAttribute"
							render={(data: MetadataAttribute) => {
								return <span>{data.isPrimaryAttribute ? '是' : '否'}</span>
							}}
						/>
						<AppTable.Col title="字段长度" align="center" field="length" />
						<AppTable.ColAction
							render={(data: MetadataEntity) => {
								return (
									<React.Fragment>
										{data.isSystem ? (
											''
										) : (
											<AppTableAction
												onClick={() => {
													this.editTableItem(data)
												}}
												label="编辑"
											/>
										)}
										{data.isSystem ? (
											''
										) : (
											<AppTableAction onClick={() => this.deleteTableItem(data)} label="删除" />
										)}
									</React.Fragment>
								)
							}}
						/>
					</AppTable>
				</AppGridView>
			</AppGridLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/components/FieldInformation.tsx